<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Tłumaczenia</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Tłumaczenia</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Tłumaczenia</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @click-row="editRow"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text" @click="setSort">
                      {{ header.text }}
                    </span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                    <div v-if="header.radio" class="radio-filter">
                      Tylko puste
                      <input
                        type="checkbox"
                        v-model="radioValue[header.value]"
                        @click="setRadioFilter()"
                      />
                    </div>
                  </template>
                  <template #item-actions="item">
                    <div>
                      <button
                        v-if="item.isEdit && canChange"
                        @click="editSend"
                        class="btn btn-success btn-xs"
                      >
                        <i class="fa fa-check"></i>
                      </button>
                      <button
                        v-if="item.isEdit"
                        @click.stop="cancelEdit(item)"
                        class="btn btn-danger btn-xs"
                      >
                        <span class="fa fa-times"></span>
                      </button>
                      <button
                        v-if="!item.isEdit && canChange"
                        @click="editRow(item)"
                        class="btn btn-warning btn-xs"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                    </div>
                  </template>
                  <template #item-pl="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.pl"
                          name="pl"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                        <div v-if="errorsAdminData?.data?.pl" class="has-error">
                          <span class="help-block">
                            {{ errorsAdminData.data.pl[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else>
                      {{ item.pl }}
                    </span>
                  </template>
                  <template #item-en="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.en"
                          name="en"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                        <div v-if="errorsAdminData?.data?.en" class="has-error">
                          <span class="help-block">
                            {{ errorsAdminData.data.en[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else>
                      {{ item.en }}
                    </span>
                  </template>
                  <template #item-cpde="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.cpde"
                          name="cpde"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.cpde"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.cpde[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else>
                      {{ item.cpde }}
                    </span>
                  </template>
                  <template #item-cpen="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.cpen"
                          name="cpen"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.cpen"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.cpen[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else>
                      {{ item.cpen }}
                    </span>
                  </template>
                  <template #item-de="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.de"
                          name="de"
                          class="form-control inputClass"
                          type="text"
                        />
                        <div v-if="errorsAdminData?.data?.de" class="has-error">
                          <span class="help-block">
                            {{ errorsAdminData.data.de[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else>
                      {{ item.de }}
                    </span>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { translationPermissionsConst } from "../../constants/translationConstants";

export default {
  name: "TranslationsList",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const store = useStore();
    const canChange = computed(() =>
      hasPermission(translationPermissionsConst.update)
    );
    const translateData = computed(() => store.getters.gettranslateData);
    const updateTranslationsData = computed(
      () => store.getters.getUpdateTranslationsData
    );
    const translationsData = computed(() => store.getters.getTranslationsData);
    const translateObj = ref({
      name: "",
      value: false,
    });
    const errorsAdminData = ref();
    let headers = [
      { text: "Nr", value: "pk" },
      { text: "Moduł", value: "module", sortable: true, search: true },
      { text: "Typ", value: "type", sortable: true, search: true },
      { text: "Kontroller", value: "controller", sortable: true, search: true },
      { text: "Nr", value: "number", sortable: true, search: true },
      {
        text: "Tekst",
        value: "text",
        sortable: true,
        search: true,
      },
      {
        text: "Polski",
        value: "pl",
        sortable: true,
        search: true,
      },
      {
        text: "Niemiecki",
        value: "de",
        sortable: true,
        radio: true,
        search: true,
      },
      {
        text: "Angielski",
        value: "en",
        sortable: true,
        radio: true,
        search: true,
      },
      {
        text: "Niemiecki (de)",
        value: "cpde",
        sortable: true,
        radio: true,
        search: true,
      },
      {
        text: "Angielski (de)",
        value: "cpen",
        sortable: true,
        radio: true,
        search: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const loading = ref(true);
    const searchValue = ref({});
    const radioValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });

    const getTranslations = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getTranslations", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        radio: radioValue.value,
      });
    };

    const saveEdit = () => {
      if (!canChange.value) {
        return;
      }

      store.dispatch("updateTranslations", translateObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editSend = () => {
      if (!canChange.value) {
        return;
      }

      store.dispatch("updateTranslations", translateObj.value);
    };

    const cancelEdit = (item) => {
      var keyObj = false;
      for (const [key, value] of Object.entries(items.value)) {
        items.value[key].isEdit = false;
        if (value.pk === item.pk) {
          keyObj = key;
        }
      }
      item.isEdit = false;
      if (keyObj) {
        translateObj.value = item;
        items.value[keyObj].isEdit = false;
      }
    };

    const editRow = (item) => {
      if (!canChange.value) {
        return;
      }

      var keyObj = false;
      for (const [key, value] of Object.entries(items.value)) {
        items.value[key].isEdit = false;
        if (value.pk === item.pk) {
          keyObj = key;
        }
      }

      if (keyObj) {
        translateObj.value = item;
        items.value[keyObj].isEdit = true;
      }
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getTranslations();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      radioValue.value = {};
      serverOptions.value.sortBy = "";
      getTranslations();
    };

    const updateSort = () => {
      search.value = true;
    };

    const setRadioFilter = () => {
      isSearch.value = true;
    };

    const setSort = () => {
      isSearch.value = false;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("transSearchValue") !== null) {
        searchValue.value = localStorage.getItem("transSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (localStorage.getItem("transRadioValue") !== null) {
        radioValue.value = localStorage.getItem("transRadioValue");
        radioValue.value = JSON.parse(radioValue.value);
      }
      getTranslations();
    });

    watch(
      () => [searchValue.value, radioValue.value],
      function () {
        localStorage.setItem(
          "transSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "transRadioValue",
          JSON.stringify(radioValue.value)
        );
        getTranslations();
      },
      { deep: true }
    );

    watch(
      () => translationsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => translateData.value,
      function (newValue) {
        translateObj.value = newValue.data;
      }
    );

    watch(
      () => radioValue.value,
      function () {
        getTranslations();
      },
      { deep: true }
    );

    watch(
      () => updateTranslationsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getTranslations();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getTranslations();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      canChange,
      serverOptions,
      translateObj,
      cancel,
      saveEdit,
      cancelEdit,
      editRow,
      errorsAdminData,
      editSend,
      searchValue,
      radioValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      setRadioFilter,
      setSort,
      selectPage,
      setRowsPerPage,
    };
  },
  computed: {},
};
</script>
